import React, { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import Modal from '../../components/Modal'
import { Checkbox, Input } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createGradeWeight, updateGradeWeight } from '../../actions/directory'
import styles from './styles.module.scss'
import Confirmation from '../../components/Confirmation/Confirmation'

export default function GradeWeightModal({ closeModal, selectedItem }) {
  const dispatch = useDispatch()

  const [confirmClose, setConfirmClose] = useState(false)
  const [weightError, setWeightError] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  const addMode = !selectedItem?.weight

  const handleCreateWeight = (values) => {
    const forRequest = {
      weight: +values.weight,
      enabled: values.enabled ? -1 : 0,
      color: values.color,
    }
    dispatch(createGradeWeight(forRequest))
    closeModal()
  }

  const handleCheck = (values) => {
    const forRequest = {
      weight: +values.weight,
      enabled: values.enabled ? -1 : 0,
      color: values.color,
    }
    dispatch(updateGradeWeight(forRequest, values.weight))
    closeModal()
  }

  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: !addMode ? { ...selectedItem, enabled: selectedItem.enabled !== 0 ? true : false } : {
      weight: '',
      enabled: false,
      color: '3689FF'
    },
    enableReinitialize: true,
    onSubmit: (formValues) => {
      if (!String(formValues.weight ?? '').trim()) {
        setWeightError(true)
        return
      }
      setWeightError(false)
      if (addMode) handleCreateWeight(formValues)
      else handleCheck(formValues)
    }
  })

  const handleWeightChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, '')
    setWeightError(false)
    setFieldValue('weight', digitsOnly)
  }

  const handleColorChange = (e) => {
    setFieldValue('color', e.target.value.replace('#', ''))
  }

  return (
    <Modal open={!!selectedItem} compact onClose={handleClose} closeOnOverlayClick={true} closeOnEsc={true}>
      {!!values && (
        <>
          <div className={styles.modalMain}>
            <h2 className={styles.modalTitle}>{addMode ? 'Добавление веса оценки' : 'Редактирование веса оценки'}</h2>
            <div className={styles.inputsColumn}>
              <Input
                label='Вес'
                name='weight'
                className={styles.weightField}
                inputName={styles.weightInput}
                value={values.weight}
                error={weightError ? 'Поле «Вес» обязательно для заполнения' : ''}
                onChange={handleWeightChange}
                disabled={!addMode}
              />
              <div>
                <p className={styles.colorField}>Цвет</p>
                <input
                  type='color'
                  className={styles.colorInput}
                  name='color'
                  value={`#${values.color || '000000'}`}
                  onChange={handleColorChange}
                />
              </div>
              <Checkbox label='Доступен' checked={values.enabled} value={values.enabled} onChange={handleChange} name='enabled' />
            </div>
          </div>
          <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
        </>
      )}
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
